import React from 'react';
import './Home_Bottom.css';

const Home_Bottom = () => {
  return (
    <div className="container d-flex justify-content-center align-items-center min-height">
      <div className="text-center">
        <h1>Discover More</h1>
        <p>Explore our Hand Picked Destination and create a memory that last life Time</p>
        <button className="btn btn-primary mt-3" >View All Destination</button>
      </div>
    </div>
  );
};

export default Home_Bottom;
